import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

interface Props {
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
}

const IconButtonOutlinedStyled = styled(IconButton)<Props>(({ theme, color }) => ({
  border: `2px solid ${theme.colors.secondary}`,
  borderRadius: '10px',
  padding: '0.5rem',
  width: 'fit-content',
  backgroundColor: theme.colors.whiteBackground,
  '&:hover': {
    borderColor: theme.colors.primary,
  },
  '& > svg': {
    fill: color ? theme.palette[color].main : 'inherit',
  },
  '&:hover > svg': {
    fill: theme.colors.primary,
  },
}))

export default function IconButtonOutlined({
  title,
  ...props
}: Omit<IconButtonProps, 'color'> & Props) {
  return (
    <Tooltip title={title}>
      <IconButtonOutlinedStyled {...props} />
    </Tooltip>
  )
}
